import React, { useEffect, useState } from 'react';
import {
    useParams
} from "react-router-dom";
import { findLancamentoByCodigo } from '../api-lancamento';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { Container, Divider, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import { dateFormat } from '../../../util/DateUtil';
import { currencyRound } from '../../../util/DoubleUtil';
import Button from '../../UI/Button';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    successBox: {
        backgroundColor: '#b0f3a1',
        borderColor: '#2cf400',
        borderStyle: 'solid',
        borderRadius: '20px',
    },
    notSuccessBox: {
        backgroundColor: '#faa0a6',
        borderColor: '#db0e1a',
        borderStyle: 'solid',
        borderRadius: '15px',
    }
})

const LancamentoPagamentoPorCreditoRetornoContainer = () => {
    const { codLancamento } = useParams();
    const [lancamento, setLancamento] = useState(null);
    const classes = useStyles();


    useEffect(() => {
        if (codLancamento) {
            findLancamentoByCodigo(codLancamento).then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.message);
                    } else {
                        setLancamento(data);
                    }
                }
            })
        }
    }, [codLancamento]);

    return (
        <Container maxWidth='sm' component={Paper}
            style={{
                marginTop: 20,
                paddingTop: 20,
                paddingBottom: 20
            }}
        >
            <Grid container spacing={2} justifyContent='center' >

                {lancamento && lancamento.cartaoCreditoTransacao ?
                    <>
                        {lancamento.cartaoCreditoTransacao.retorno === "OK" ?
                            <Grid item xs={12}
                                className={classes.successBox}
                            >
                                <Typography variant='body1'>
                                    Pagamento Realizado com Sucesso.
                                </Typography>




                            </Grid> :
                            <Grid item xs={12}
                                className={classes.notSuccessBox}
                            >
                                <Typography variant='body1'>
                                    Ocorreu um erro na transação do Cartão de Crédito.
                                </Typography>
                                <Typography variant='body1'>
                                    {lancamento.cartaoCreditoTransacao.detalhesErro}
                                </Typography>




                            </Grid>
                        }
                    </>
                    :
                    <Grid item xs={12}
                        className={classes.notSuccessBox}
                    >
                        <Typography variant='body1'>
                            Lançamento sem pagamento com Cartão de Crédito
                        </Typography>




                    </Grid>
                }

                <Grid item xs={12}>
                    <Typography variant='body1' style={{ fontWeight: 'bold', textAlign: 'center' }}>Lançamento</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row'>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                Ano Letivo
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                {lancamento?.anoLetivo}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row'>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                Aluno
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                {lancamento?.aluno?.nome}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row'>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                Histórico
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                {lancamento?.historicoLancamento?.descricao}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row'>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                Data Vencimento
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                {lancamento && lancamento.dataVencimento ? dateFormat(lancamento.dataVencimento) : ''}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row'>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                Data Pagamento
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                {lancamento?.dataPagamento ? dateFormat(lancamento.dataPagamento) : ''}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row'>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                Valor Pago
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant='body1'>
                                {lancamento?.valorPago ? currencyRound(lancamento.valorPago) : ''}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Button component={Link} to='/financeiro-responsavel'>Voltar</Button>
                </Grid>

            </Grid>
        </Container >
    );
}

export default LancamentoPagamentoPorCreditoRetornoContainer;